/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TenancyStatuses {
    IN_PROGRESS = 'InProgress',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}